<template>
  <modal @close="$emit('close')" :wide="true">
    <div class="px-5">
      <div v-if="!saved">
        <div class="flex flex-col text-center w-full justify-center items-center">
          <p class="font-bold text-sm text-main-text">Вы уверены, что хотите изменить количество
            команд-чемпионов?</p>
        </div>
        <div class="py-8 text-main-text">
          <div class="flex text-center w-full justify-center items-center">
            <button @click="$emit('close')"
                    class="ml-4 mr-1 outline-none hover-up text-nowrap border-2  font-bold text-black rounded-full py-3 w-48 md:w-32">
              <span class="flex justify-center text-xs text-main-text">Отменить</span>
            </button>
            <button
                @click="$emit('startNewSeason')"
                class="mr-4 ml-1 outline-none hover-up text-nowrap font-bold bg-brand-yellow px-1 text-black rounded-full py-3 w-48">
              <span class="text-xs text-main-text">Сохранить</span>
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="pb-12 pt-4 text-main-text w-full text-lg text-center w-full">Изменения произошли успешно</p>
      </div>
    </div>
  </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals';
import Modal from '@/views/modals/base-modal-white.vue';

export default {
  name: 'saveHighlights',
  components: {Modal},
  mixins: [ModalMixin],
  props: {
    saved: {
      type: Boolean,
      default: false,
    },
  },
};

</script>